import { Id, Json, JsonEntity } from '@homeleite/arch';
import { ProducerSummary } from '../producers';
import { EMPTY } from '@homeleite/common-utils';

export class ControllerSummary implements JsonEntity {
    constructor(
        public readonly id = Id.gen(),
        public readonly name = EMPTY,
        public readonly code = EMPTY,
        public active = true,
        public producersCount = 0,
        public email = EMPTY,
    ) {}

    toJson() {
        return Json.to.simple(this);
    }

    static fromJson(json: any) {
        if (!json) {
            return null;
        }
        return Json.from.simple(json, ControllerSummary, {
            active: json.active ?? json.isActive ?? true,
            producersCount: Number(json.producersCount ?? json.producers?.length ?? 0) || 0,
            email: json.email ?? EMPTY,
        });
    }
}

export class Controller implements JsonEntity {
    constructor(
        public readonly id = Id.gen(),
        public name = EMPTY,
        public identificationNumber = EMPTY,
        public code = EMPTY,
        public email = EMPTY,
        public active = true,
        public producers: ProducerSummary[] = [],
        public activeProducers: ProducerSummary[] = []
    ) {}

    toJson() {
        return Json.to.simple(this, {
            producers: this.producers.map((it) => it.toJson()),
            activeProducers: this.activeProducers.map((it) => it.toJson())
        });
    }

    static fromJson(json: any) {
        return json
            ? Json.from.simple(json, Controller, {
                  producers: Json.from.array(json.producers, ProducerSummary.fromJson),
                  activeProducers: Json.from.array(json.activeProducers, ProducerSummary.fromJson)
              })
            : null;
    }
}
